import React from 'react';
import PropTypes from 'prop-types';
import Chart from "react-apexcharts";
import Card, {
    CardPrimaryContent,
    // CardMedia,
    // CardActions,
    // CardActionButtons,
    // CardActionIcons
  } from "@material/react-card";

  import '../NPSDashboard/NPSDashboard.scss';

const NPSChart = ({sentimentDistnTable, questions, yAxisTitle, dimension, children, className, customTooltip}) => {
   
    // const options = selectedRankedItem === "" ? _getOptions(values, handleSelectedDatapoint) : 
    //                                           _updateOptions(values,  handleSelectedDatapoint, selectedRankedItem)
   // const height = '350px';
    let heightStyle = {
        height : '362px'
    }
    let chart = <div style={heightStyle}>No Data Available</div>
    const options =  _getOptions(sentimentDistnTable, dimension, questions, customTooltip)
    const series = _getSeries(sentimentDistnTable, yAxisTitle)
   // console.dir(series)
    // if table is  not empty
    // console.dir(sentimentDistnTable)
    if (sentimentDistnTable.length !== 1) {
      
        chart =  <Chart
                            options={options}
                            series={series}
                            type="bar"
                            width="100%"
                            height='350px'
                        />
    }
   
    
    return (
            
            <div className={"bar-chart " + className} >
               
                <Card>
                    <CardPrimaryContent>
                        {children}
                        {chart}
                    </CardPrimaryContent>
                </Card>
             </div>
  )
}

const roundToDp = (num, dec)=> {
       
    if ((typeof num !== 'number') || (typeof dec !== 'number'))
        return false;

    var num_sign = num >= 0 ? 1 : -1;

    return Number( (Math.round((num * Math.pow(10, dec)) + (num_sign * 0.0001)) / Math.pow(10, dec)).toFixed(dec) );
}


const _getSeries = (sentimentDistnTable, name='frequency') => {
    const sentiments = Object.keys(sentimentDistnTable[0]).filter((key)=> key !== 'questionLabel' && key !== 'questionValue' && key !== 'dimCategory')
    

    let series = []
    let data = []
   // const sentiment = sentiments[0]
    
    for (let sentiment of sentiments) {
        data = sentimentDistnTable.map((row)=> {
            if (sentiment === 'Strongly Disagree' || sentiment === 'Disagree') {
                return -1*row[sentiment]
            } else {
                return row[sentiment]
            }
        })
        series.push({
           name: sentiment,
           data
       })
    }

    return series
   
}


const _getOptions = (sentimentDistnTable, dimension, questions, customTooltip)=> {
    let percentage = null;
    let sentiment = null;
    const options = {
            plotOptions: {
                bar: {
                    horizontal: true,
                    barHeight: '70%'
                }
            },
            stroke: {
                show: true,
                lineCap: 'round'
            },
            chart: {
              id: "basic-bar",
              stacked: true,
              events: {
                dataPointSelection: function(event, chartContext, config) {
                    // console.dir(config)
                    // console.dir(config.w.config)
                    const seriesIndex = config.seriesIndex;
                    const dataPointIndex = config.dataPointIndex;
                    percentage = config.w.config.series[seriesIndex].data[dataPointIndex]
                    sentiment = config.w.config.series[seriesIndex].name.toLowerCase()
                },
                dataPointMouseEnter: function(event, chartContext, config) {
                    // console.dir(config)
                    // console.dir(config.w.config)
                    const seriesIndex = config.seriesIndex;
                    const dataPointIndex = config.dataPointIndex;
                    percentage = config.w.config.series[seriesIndex].data[dataPointIndex]
                    sentiment = config.w.config.series[seriesIndex].name.toLowerCase()
                },
              }
            },
           // colors: ['#DFC35A', '#E5DA9E', '#99B0C0', '#8DBBD0', '#649DBB'],
           // colors: [ '#649DBB', '#DFC35A', '#8DBBD0', '#E5DA9E', '#99B0C0'  ],
           colors: [ '#99B0C0', '#8DBBD0', '#649DBB', '#E5DA9E', '#DFC35A'  ],
           
            tooltip: {
                enabled: true,
                theme: 'dark',
                y: {
                    formatter: (value) => { return Math.abs(value) + "%" }
                },
                x: {
                    formatter: function(value) { 
                        return customTooltip(value, sentimentDistnTable, dimension, questions, sentiment, percentage)
                        
                    }
                },
                fixed: {
                    enabled: true,
                    position: 'topLeft',
                    offsetX: 0
                }              

            },
            dataLabels: {
                 enabled: false,
                style: {
                    fontSize: '16px',
                    fontFamily: 'Rubik, Arial, sans-serif',
                    cssClass: 'apex-datalabels',
                  //  colors: ['#000']
                },
               formatter: (value) => { return roundToDp(value,1) + '%' },

            },
            // title: {
            //     text: 'Do you care about data? Here is a survey conducted with data visualization professionals who responded to how often people use their data visualizations',
            //     align: 'center',
            //     margin: 10,
            //     offsetX: 0,
            //     offsetY: 0,
            //     floating: false,
            //     style: {
            //       fontSize:  '34px',
            //       color:  '#000',
            //       cssClass: 'apex-title'
            //     },
            // },
            xaxis: {
              categories: sentimentDistnTable.map(row=>row.questionLabel),
              border: {
                  show: true
              },
              min: -100,
              max: 100,
              title: {
                text: "Respondents",
                rotate: -90,
                // offsetX: 0,
                // offsetY: 0,
                style: {
                  //  color: undefined,
                    fontSize: '16px',
                    fontFamily: 'Rubik, Arial, sans-serif',
                    cssClass: 'apexcharts-yaxis-title',
                },
               },
               labels: {
                show: true,
               // align: 'right',
                // minWidth: 0,
                // maxWidth: 160,
                style: {
                    color: undefined,
                    fontSize: '14px',
                    fontFamily: 'Rubik, Arial, sans-serif',
                    cssClass: 'apexcharts-xaxis-label',
                },
               
                // offsetX: 0,
                // offsetY: 0,
                // rotate: 0,
                //formatter: (value) => { return Math.abs(Math.round(value)) },
                formatter: (value) => { return Math.round(value) },

              },
            //  floating: true,
              axisTicks: {
                show: true
              },
              axisBorder: {
                show: true
              },
            },
            yaxis: {
                // min: -100,
                // max: 100,
                labels: {
                    show: true,
                    // align: 'right',
                    minWidth: 0,
                    maxWidth: 100,
                    style: {
                        color: undefined,
                        fontSize: '16px',
                        fontFamily: 'Rubik, Arial, sans-serif',
                        cssClass: 'apexcharts-yaxis-label',
                    },
                    // offsetX: -10,
                    // offsetY: 0,
                    // rotate: 0,
                    formatter: (value) => { return value },
                  },
                  axisBorder: {
                    show: true
                  },
            },
            legend: {
                show: false,
                position: 'top',
                horizontalAlign: 'right'
            },
            responsive: [
               
                // {
                //     breakpoint: 1920,
                //     options: {
                //         yaxis: {
                //             min: -100,
                //             max: 100,
                //             labels: {
                //                 show: true,
                //                 // align: 'right',
                //                 minWidth: 0,
                //                 maxWidth: 100,
                //                 style: {
                //                     color: '#ccc',
                //                     fontSize: '16px',
                //                     fontFamily: 'Rubik, Arial, sans-serif',
                //                     cssClass: 'apexcharts-yaxis-label',
                //                 },
                //                 // offsetX: -10,
                //                 // offsetY: 0,
                //                 // rotate: 0,
                //                 formatter: (value) => { return value },
                //               },
                //               axisBorder: {
                //                 show: true
                //               },
                //         }
                //     }
                // }
            ]
        }

      return  Object.assign({}, options);
}

NPSChart.propTypes = {
   
    sentimentDistnTable: PropTypes.array.isRequired,
    yAxisTitle: PropTypes.string.isRequired
}

export default NPSChart